import PointsExpirationInlineDialog from "./PointsExpirationInlineDialog";

export * from "./PointsExpirationInlineDialog.types";

export default PointsExpirationInlineDialog;
